import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { getTimelineData } from "../../services/timeline-service";
import Loader from "../../assets/loader.gif";
import InputBox from "../common/InputBox";

const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return "";
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export default function IsobTab5({ formValues, handleInputChange, orderBookingFormData, enquiryData, readOnly,error,setError,mandatoryFields,setMandatoryFields }) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const [timelineRecord, setTimelineRecord] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 767);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchData = async () => {
        try {
            // debugger
            setLoading(true);
            const response = await getTimelineData();
            console.log("timeline data:: ", response.data);
            const latestTimelineRecord = (response.data || []).filter((timeline) => (Number(timeline.Title) === enquiryData?.ID) || (Number(timeline.Title) === Number(orderBookingFormData?.Title)));
            setTimelineRecord(latestTimelineRecord[0] || {});
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("error in catch", error);
            setTimelineRecord({});
        }
    };

    const isobTimeline = {
        lotName: "PreOrder Timeline",
        designStart: timelineRecord.field_18,
        designFinish: timelineRecord.field_19,
        supplyStart: timelineRecord.field_21,
        supplyFinish: timelineRecord.field_22,
        installationStart: timelineRecord.field_24,
        installationFinish: timelineRecord.field_25,
        zeroDate: timelineRecord.field_8,       // Temporarily used Site Readiness Date
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (isMobile) {
        const sections = [
            { title: "Design", start: isobTimeline.designStart, finish: isobTimeline.designFinish },
            { title: "Supply", start: isobTimeline.supplyStart, finish: isobTimeline.supplyFinish },
            { title: "Installation", start: isobTimeline.installationStart, finish: isobTimeline.installationFinish },
        ];

        return (
            <>
                {loading && (
                    <div className="loader-box">
                        {" "}
                        <img src={Loader} alt="Loading" className="newloader"></img>{" "}
                    </div>
                )}

                <div className="form-right-adjust isob-tab5-mobile">
                    <div className="isob-tab5-timeline-card-view">
                        {sections.map((section) => (
                            <div key={section.title} className="isob-tab5-mobile-card">
                                <div className="isob-tab5-mobile-card-title">{section.title}</div>
                                <div className="isob-tab5-mobile-card-lot">{isobTimeline.lotName}</div>
                                <div className="isob-tab5-mobile-card-dates">
                                    <div className="isob-tab5-mobile-date-col">
                                        <span className="isob-tab5-mobile-date-label">Start date</span>
                                        <span className="isob-tab5-mobile-date-value">{formatDate(section.start) || "-"}</span>
                                    </div>
                                    <div className="isob-tab5-mobile-date-col">
                                        <span className="isob-tab5-mobile-date-label">Finish date</span>
                                        <span className="isob-tab5-mobile-date-value">{formatDate(section.finish) || "-"}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className="isob-tab5-mobile-card">
                            <div className="isob-tab5-mobile-card-title">Remarks</div>
                            <div className="isob-tab5-mobile-card-lot">{isobTimeline.lotName}</div>
                            <div className="isob-tab5-mobile-card-dates">
                                <div className="isob-tab5-mobile-date-col">
                                    <span className="isob-tab5-mobile-date-label">Zero date</span>
                                    <span className="isob-tab5-mobile-date-value">{formatDate(isobTimeline.zeroDate) || "-"}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="remarks-header">
                        <h6 className="section-subheading-plain ob-section-heading-flex">
                            Any other information
                        </h6>
                    </div>
                     <InputBox
                        type="text"
                        as="textarea"
                        name="timelineOtherInformation"
                        className="remarks-textarea"
                        label="Any other information"
                        value={formValues.timelineOtherInformation || ""}
                        onChange={(e) => handleInputChange({ target: { name: "timelineOtherInformation", value: e.target.value.slice(0, 500) } })}
                        maxLength={500}
                        isAlphanumericWithSpecialChars
                        readOnly={readOnly}
                        error={error?.timelineOtherInformation}
                        setError={setError}
                        mandatoryFields={mandatoryFields}
                        setMandatoryFields={setMandatoryFields}
                        fieldName="Any other information"
                     />
                </div>
            </>
        );
    }

    const hasData = isobTimeline.designStart || isobTimeline.supplyStart || isobTimeline.installationStart || isobTimeline.zeroDate;

    return (
        <>
            {loading && (
                <div className="loader-box">
                    {" "}
                    <img src={Loader} alt="Loading" className="newloader"></img>{" "}
                </div>
            )}

            <div className="form-right-adjust">
                <p className="timeline-heading">Project Timelines</p>

                <div className="order-info-section-plain-nopad-nomar add-edit-form">
                    <div className="timeline-table-wrapper">
                        <table className="timeline-table">
                            <thead className="timeline-table-head">
                                <tr className="timeline-table-header-row">
                                    <th rowSpan={2} className="timeline-th timeline-th-lotname">Lot Name</th>
                                    <th colSpan={2} className="timeline-th timeline-th-group">Design</th>
                                    <th colSpan={2} className="timeline-th timeline-th-group">Supply</th>
                                    <th colSpan={2} className="timeline-th timeline-th-group">Installation</th>
                                    <th colSpan={2} className="timeline-th timeline-th-group">Remarks</th>
                                </tr>
                                <tr className="timeline-table-subheader-row">
                                    <th className="timeline-th-sub">Start</th>
                                    <th className="timeline-th-sub timeline-th-sub-last">Finish</th>
                                    <th className="timeline-th-sub">Start</th>
                                    <th className="timeline-th-sub timeline-th-sub-last">Finish</th>
                                    <th className="timeline-th-sub">Start</th>
                                    <th className="timeline-th-sub timeline-th-sub-last">Finish</th>
                                    <th className="timeline-th-sub">Zero Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {hasData ? (
                                    <tr className="timeline-table-body-row">
                                        <td className="timeline-td timeline-td-lotname">{isobTimeline.lotName}</td>
                                        <td className="timeline-td">{formatDate(isobTimeline.designStart)}</td>
                                        <td className="timeline-td timeline-td-last">{formatDate(isobTimeline.designFinish)}</td>
                                        <td className="timeline-td">{formatDate(isobTimeline.supplyStart)}</td>
                                        <td className="timeline-td timeline-td-last">{formatDate(isobTimeline.supplyFinish)}</td>
                                        <td className="timeline-td">{formatDate(isobTimeline.installationStart)}</td>
                                        <td className="timeline-td timeline-td-last">{formatDate(isobTimeline.installationFinish)}</td>
                                        <td className="timeline-td">{formatDate(isobTimeline.zeroDate)}</td>
                                    </tr>
                                ) : (
                                    <tr className="timeline-table-body-row">
                                        <td colSpan={12} className="timeline-td timeline-td-empty">No timeline record available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="remarks-header">
                    <h6 className="section-subheading-plain ob-section-heading-flex">
                        Any other information
                    </h6>
                </div>
                <InputBox
                    type="text"
                    as="textarea"
                    style={{
                                "max-width": '98%',
                                "min-width": '50%',
                                "width": '-webkit-fill-available',
                                "min-height": "30px"                            }}
                    name="timelineOtherInformation"
                    id="timelineOtherInformation"
                    label="Any other information"
                    value={formValues.timelineOtherInformation || ""}
                    onChange={(e) => handleInputChange({ target: { name: "timelineOtherInformation", value: e.target.value.slice(0, 500) } })}
                    maxLength={500}
                    isAlphanumericWithSpecialChars
                    readOnly={readOnly}
                    error={error?.timelineOtherInformation}
                    setError={setError}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    fieldName="Any other information"
                />
            </div>
        </>
    );
}
